(function (angular) {
    "use strict";
    angular.module('smartpublic.core').controller('ProvidersController',
        ProvidersController);

    ProvidersController.$inject = ['$log', 'ProvidersFactory', '$timeout', 'NgMap', "$scope", '$q'];

    function ProvidersController($log, ProvidersFactory, $timeout, NgMap, $scope, $q) {

        var vm = this;

        var districtSelectPicker = angular.element(document.querySelector('#district'));
        var municipalitySelectPicker = angular.element(document.querySelector('#municipality'));
        var specialtySelectPicker = angular.element(document.querySelector('#specialty'));
        var pageSize = angular.element(document.querySelector('#pageSize'));
        var orderBy = angular.element(document.querySelector('#orderBy'));
        var lastQuery = null;
        var EMPTY_COORDS = '0.0,0.0';


        vm.getDistricts = getDistricts;
        vm.getMunicipalities = getMunicipalities;
        vm.getSpecialty = getSpecialty;
        vm.resetSearchFilters = resetSearchFilters;
        vm.search = search;
        vm.loadMore = loadMore;
        vm.selectMapMarker = selectMapMarker;

        vm.showQueryError = false;
        vm.showNoResults = false;
        vm.loading = false;
        vm.loadingMoreSpinner = false;

        init();

        function init() {

            vm.districtList = [];
            vm.municipalityList = [];
            vm.specialtyList = [];

            vm.data = {
                pageSize: "10",
                page: 1,
                sort: "asc",
                order: "PRVN"
            };

            vm.showDistrictError = false;
            vm.providers = [];
            vm.searchResult = null;

            getDistricts();
            getMunicipalities();
            getSpecialty();

        }

        function getDistricts(municipalityCode) {

            var districtCode;

            if (municipalityCode) {
                var x;

                districtCode = vm.municipalityList.filter(function (x) {
                    return x.ccCode === municipalityCode;
                })[0].dcCode;
                vm.data.district = districtCode;
                $timeout(function () {
                    districtSelectPicker.selectpicker('refresh');
                });
            }
            else {
                ProvidersFactory.getDistricts(municipalityCode).then(
                    function (resp) {
                        var data = resp.data;

                        if (data) {
                            if (municipalityCode) {
                                vm.data.district = vm.districtList[0];
                            } else {
                                vm.districtList = data;
                            }

                        } else {
                            // TODO error
                        }

                        $timeout(function () {
                            districtSelectPicker.selectpicker('refresh');
                        });

                    }, function (error) {
                        // TODO error
                    });
            }

        }

        function getMunicipalities(districtCode) {

            ProvidersFactory.getMunicipalities(districtCode).then(
                function (resp) {
                    var data = resp.data;

                    if (data) {
                        vm.municipalityList = data;
                    } else {
                        // TODO error
                    }

                    $timeout(function () {
                        municipalitySelectPicker.selectpicker('refresh');
                    });

                }, function (error) {
                    // TODO error
                });
        }

        function getSpecialty() {

            ProvidersFactory.getSpecialty().then(function (resp) {
                var data = resp.data;

                if (data) {
                    vm.specialtyList = data;
                } else {
                    // TODO error
                }

                $timeout(function () {
                    specialtySelectPicker.selectpicker('refresh');
                });

            }, function (error) {
                // TODO error
            });
        }

        function resetSearchFilters() {
            init();
        }

        function search() {

            vm.data.page = 1;
            vm.loading = true;
            vm.showQueryError = false;
            vm.showNoResults = false;
            vm.providers = [];
            vm.searchResult = null;
            ProvidersFactory.getProviders(vm.data).then(function (resp) {
                console.log("providers ", resp);

                vm.providers = resp.data.providers;
                if (vm.providers.length) {

                    lastQuery = angular.copy(vm.data);
                    vm.searchResult = resp.data;
                    deselectAllPrvs();
                    fitAndCenterMap();
                } else {
                    vm.showNoResults = true;
                }


            }, function (error) {
                console.log("search error", error);
                if (error.status == 409) {
                    vm.showQueryError = "Pesquisa inválida. Os campos distrito e concelho são obrigatórios.";
                } else {
                    vm.showQueryError = "Ocorreu um erro na pesquisa."
                }
                // TODO error
            }).finally(function () {
                vm.loading = false;
            });
        }

        function loadMore() {
            lastQuery.page++;
            console.log("loading more with query", lastQuery);
            vm.loadingMoreSpinner = true;
            ProvidersFactory.getProviders(lastQuery).then(function (resp) {
                console.log("providers ", resp);

                vm.searchResult = resp.data;
                Array.prototype.push.apply(vm.providers, resp.data.providers);
                deselectAllPrvs();

            }, function (error) {
                // TODO error
            }).finally(function () {
                vm.loadingMoreSpinner = false;
            });
        }


        function fitAndCenterMap() {

            var bounds = new google.maps.LatLngBounds();

            var coords = vm.providers.filter(function (p) {
                return p.gpsCoordinates && p.gpsCoordinates != EMPTY_COORDS;
            }).map(function (p2) {
                return p2.gpsCoordinates.split(",");
            });

            console.log("coords ", coords);

            if (coords.length == 0) {
                //then there is no coords info to center
                return;
            }

            for (var i = 0; i < coords.length; i++) {
                var latlng = new google.maps.LatLng(coords[i][0], coords[i][1]);
                console.log("latlng", latlng);
                bounds.extend(latlng);
            }

            NgMap.getMap("prvMap").then(function (map) {
                console.log("Map", map);
                map.setCenter(bounds.getCenter());
                map.fitBounds(bounds);
                $timeout(function () {
                    google.maps.event.trigger(map, 'resize');

                });
            });

        }

        function selectMapMarker(prv) {

            if (prv.gpsCoordinates == EMPTY_COORDS) {
                console.log("No coords for prv", prv.name);
                return;
            }

            NgMap.getMap("prvMap").then(function (map) {
                var coords = coordsToLatLng(prv.gpsCoordinates);
                console.log("select marker", coords, prv);
                deselectAllPrvs();
                prv.selected = true;
                map.setZoom(15);
                map.panTo(coords);
            });

        }

        function coordsToLatLng(gpsCoords) {
            var coords = gpsCoords.split(",");
            return {lat: parseFloat(coords[0]), lng: parseFloat(coords[1])};
        }

        function deselectAllPrvs() {
            vm.providers.forEach(function (p) {
                p.selected = false;
            });
        }


    }

})(angular);